jQuery(document).ready(function ($) {
  jQuery("a[href='#']").attr("href", "javascript:void(0)");
  jQuery(document).on(
    "click",
    ".site-header .primary_mobile_menu",
    function () {
      if (jQuery(this).hasClass("active")) {
        jQuery("body").removeClass("mobile_menu_open");
        jQuery(this).removeClass("active");
        jQuery(this).find(".menu_link_text").text("Menu");
      } else {
        jQuery("body").addClass("mobile_menu_open");
        jQuery(this).addClass("active");
        jQuery(this).find(".menu_link_text").text("Close");
      }
    }
  );

  jQuery(document).on(
    "click",
    ".site-header .menu-item.menu-item-has-children>a",
    function () {
      if (jQuery(this).parent().find(".sub-menu").is(":hidden")) {
        jQuery(".site-header .menu-item.menu-item-has-children>a").removeClass(
          "active"
        );
        jQuery(
          ".site-header .menu-item.menu-item-has-children>.sub-menu"
        ).slideUp();
        jQuery(this).addClass("active");
        jQuery(this).parent().find(".sub-menu").slideDown();
      } else {
        jQuery(this).removeClass("active");
        jQuery(this).parent().find(".sub-menu").slideUp();
      }
    }
  );
  var inner_banner_play_icon = document.querySelector(".inner_page_banner .play_icon");
  if (inner_banner_play_icon) {
    inner_banner_play_icon.addEventListener("click", function () {
      this.classList.toggle("active");
    });
  }
});

// document.addEventListener('DOMContentLoaded', function () {
//   const playIcon = document.querySelector('.play_icon');
//   const posterImage = document.querySelector('.img_poster');

//   playIcon.addEventListener('click', function () {
//       if (posterImage) {
//           posterImage.classList.toggle('video_active');
//       }
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  var slider = document.querySelector(".get_to_know_content ");

  if (slider) {
    function initSlickSlider() {
      if (window.innerWidth < 768) {
        if (!slider.classList.contains("slick-initialized")) {
          jQuery(slider).slick({
            dots: false,
            arrows: false,
            infinite: false,
            slidesToShow: 1,
            variableWidth: true,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 2000,
          });
        }
      } else {
        if (slider.classList.contains("slick-initialized")) {
          jQuery(slider).slick("unslick");
        }
      }
    }
    initSlickSlider();
    window.addEventListener("resize", function () {
      initSlickSlider();
    });
  }
});

jQuery(".inner_page_banner").each(function (index) {
  var $this = jQuery(this);
  $this.find(".play_btn").on("click", function () {
    $this.find(".img_poster").hide();
    $this.find(".play_icon ").hide();
    $this.find(".video").show();
    var videoElement = $this.find(".video video").get(0);
    videoElement.play();
    console.log("clicked");
  });
});